import type { Locale } from "@/lib/i18n";
import { pl, type CPhotoGalleryTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cPhotoGalleryTranslations: Record<Locale, CPhotoGalleryTranslations> = {
  pl,
  en,
  de,
};

export type { CPhotoGalleryTranslations };
